import script from "./TheDocumentTreca.vue?vue&type=script&setup=true&lang=js"
export * from "./TheDocumentTreca.vue?vue&type=script&setup=true&lang=js"

import "./TheDocumentTreca.vue?vue&type=style&index=0&id=51e66ad8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51e66ad8"]])

export default __exports__